import React, { useState } from 'react';
import { X, RefreshCw } from 'lucide-react';
import { extensionLineLabel } from '@/lib/sessionExtensions';
import { money } from '@/lib/posReceipt';
import ExtensionBayPicker from './ExtensionBayPicker';

// The extra time currently on the order, listed with the rest of the order
// contents. Each line stays bound to the bay it was sold for and can be moved to
// another live bay, or taken off the order.
export default function SessionExtensionLines({ extensions = [], onRemove, onRebind }) {
  // Index of the line being moved (null = no picker open).
  const [rebindIndex, setRebindIndex] = useState(null);

  if (extensions.length === 0) return null;

  return (
    <div className="space-y-1.5 pt-1">
      {extensions.map((line, i) => (
        <div
          key={`${line.key}-${i}`}
          className="flex items-center justify-between gap-2 border border-primary/25 bg-primary/[0.07] px-2.5 py-2"
        >
          <div className="min-w-0">
            <p className="text-white font-bold text-[11px] truncate">{extensionLineLabel(line)}</p>
            <p className="text-white/40 text-[10px]">+{line.minutes} min</p>
          </div>
          <div className="flex items-center gap-1 shrink-0">
            <p className="text-primary font-black text-xs">{money(line.price)}</p>
            <button
              onClick={() => setRebindIndex(i)}
              title="Move to another bay"
              className="w-6 h-6 flex items-center justify-center text-white/40 hover:text-white transition-colors"
            >
              <RefreshCw className="w-3 h-3" />
            </button>
            <button
              onClick={() => onRemove(i)}
              title="Remove"
              className="w-6 h-6 flex items-center justify-center text-white/40 hover:text-red-400 transition-colors"
            >
              <X className="w-3.5 h-3.5" />
            </button>
          </div>
        </div>
      ))}

      <ExtensionBayPicker
        open={rebindIndex !== null}
        title="Move Extension to Another Bay"
        onSelect={(bay) => {
          onRebind(rebindIndex, bay);
          setRebindIndex(null);
        }}
        onClose={() => setRebindIndex(null)}
      />
    </div>
  );
}